module.exports = __webpack_public_path__ + "img/citymesh.9b27102d.svg";